import validate from "/srv/portal/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45detected_45embed_45global from "/srv/portal/middleware/00-detectedEmbed.global.js";
import dynamic_45head_45global from "/srv/portal/middleware/dynamic-head.global.js";
import entry_45url_45global from "/srv/portal/middleware/entry-url.global.js";
import route_45rewrite_45global from "/srv/portal/middleware/route-rewrite.global.js";
import trailingslash_45global from "/srv/portal/middleware/trailingslash.global.js";
import manifest_45route_45rule from "/srv/portal/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45detected_45embed_45global,
  dynamic_45head_45global,
  entry_45url_45global,
  route_45rewrite_45global,
  trailingslash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "catch-all": () => import("/srv/portal/middleware/catchAll.js")
}